module.exports = __webpack_public_path__ + "e22ea74aa9d42e86de859d5f15dddca4.png";